import axios from "axios";
import { config } from "../../config";
import { combinedAutocompleteApiPrefix } from "../paths";
import {
  CombinedAutocompleteRequest,
  CombinedAutocompleteResponse,
} from "../../../modules/search/types";

export const fetchCombinedAutocomplete = async (
  body: CombinedAutocompleteRequest
): Promise<CombinedAutocompleteResponse> => {
  const res = await axios.post(combinedAutocompleteApiPrefix, body, {
    baseURL: config.baseURL,
  });

  if (res.data.Response === "Failure") {
    throw new Error(res.data.value);
  }

  return res.data.value;
};
